<template>
  <vuetify-aggregator-card
    ref="aggregator"
    :color="color"
    :persistent="persistent"
    :toolbar-title="theToolbarTitle"
    :list-title="listTitle"
    :navigation-menu="navigationMenu"
    :add-button-hover-text="addButtonHoverText"
    :dialog-max-width="dialogMaxWidth"
    :dialog-toolbar-title="dialogToolbarTitle"
  >
    <div slot="card-text" v-if="signature.value">
      <v-scale-transition origin="center center">
        <div v-if="signature.value">
          <v-card-media :src="signature.value || ''" class="signature-image" height="150px"></v-card-media>
        </div>
       </v-scale-transition>
    </div>
    
    <vue-signature-pad
      slot="dialog-card-text" 
      ref="signature"
      @on-save-signature="onSaveSignature"
      @on-upload-error="onUploadError"
    >
      <template slot="buttons">
        <v-layout class="signature-actions" row align-center justify-center>
          <v-tooltip top v-if="!disableUploadButton" >
            <v-btn slot="activator" outline fab color="primary" @click="selectSignatureFile()">
              <v-icon>file_upload</v-icon>
            </v-btn>
            <span>{{ uploadIconHoverText }}</span>
          </v-tooltip>
          <v-tooltip v-if="!disableClearButton" top>
            <v-btn slot="activator" outline fab color="primary" @click="clearSignature">
              <v-icon>settings_backup_restore</v-icon>
            </v-btn>
            <span>{{ clearIconHoverText }}</span>
          </v-tooltip>
          <v-tooltip v-if="!disableSaveButton" top>
            <v-btn slot="activator" outline fab color="primary" @click="setSignature()">
              <v-icon>check</v-icon>
            </v-btn>
            <span>{{ saveIconHoverText }}</span>
          </v-tooltip>
          <v-tooltip v-if="!disableDeleteButton" top>
            <v-btn slot="activator" outline fab color="primary" @click="askForConfirmation()">
              <v-icon>delete</v-icon>
            </v-btn>
            <span>{{ deleteIconHoverText }}</span>
          </v-tooltip>
          <v-tooltip v-if="!disableCancelButton" top>
            <v-btn slot="activator" outline fab color="primary" @click="closeDialog()">
              <v-icon>exit_to_app</v-icon>
            </v-btn>
            <span>Salir</span>
          </v-tooltip>
          <v-btn v-if="disableSaveButton" outline color="primary" @click="setSignature()">{{ saveIconHoverText }}</v-btn>
          <v-btn v-if="disableSaveButton" outline color="primary" @click="closeDialog()">Cancelar</v-btn>
        </v-layout>
      </template>
    </vue-signature-pad>
    <vuetify-dialog-confirm
      slot="extras"
      :headline="dialogConfirmHeadline"
      :text="dialogConfirmText"
      :cancel="cancelButton"
      :confirm="confirmButton"
      @on-cancel-dialog="onDiscardDeletion"
      @on-confirm-dialog="onConfirmDeletion"
      v-model="showConfirmDialog"
    ></vuetify-dialog-confirm>

  </vuetify-aggregator-card>
</template>

<script>
  'use strict'

  import VuetifyAggregatorCard from '@/layouts/vuetify-aggregator-card'
  import VuetifyDialogConfirm from '@/components/vuetify-dialog-confirm'
  import VueSignaturePad from '@/components/vue-signature-pad/'

  export default {

    name: 'VuetifySignatureAggregator',

    components:
    {
      VuetifyAggregatorCard,
      VuetifyDialogConfirm,
      VueSignaturePad
    },

    props: {
      options: {
        type: Object,
        default: null,
        required: true
      },
      color: {
        type: String,
        default: 'primary',
        required: false
      },
      toolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      listTitle: {
        type: String,
        default: null,
        required: true
      },
      navigationMenu: {
        type: Boolean,
        default: true,
        required: false
      },
      addButtonHoverText: {
        type: String,
        default: null,
        required: true
      },
      dialogMaxWidth: {
        type: Number,
        default: 450,
        required: false
      },
      dialogToolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      textFieldLabel: {
        type: String,
        default: 'Phone',
        required: false
      },
      textFieldRules: {
        type: Array,
        default: null,
        required: false
      },
      selectLabel: {
        type: String,
        default: 'Type',
        required: false
      },
      phoneTypes: {
        type: Array,
        default: null,
        required: false
      },
      dialogConfirmHeadline: {
        type: String,
        default: 'Delete area',
        required: false
      },
      dialogConfirmText: {
        type: String,
        default: 'Estás a punto de eliminar un área de trabajo',
        required: false
      },
      cancelButton: {
        type: String,
        default: 'Cancel',
        required: false
      },
      confirmButton: {
        type: String,
        default: 'Confirm',
        required: false
      },
      deleteIconHoverText: {
        type: String,
        default: 'Delete',
        required: false
      },
      uploadIconHoverText: {
        type: String,
        default: 'Upload image of 400 x 200 pixels in PNG format',
        required: false
      },
      clearIconHoverText: {
        type: String,
        default: 'Clean signature',
        required: false
      },
      saveIconHoverText: {
        type: String,
        default: 'Save signature',
        required: false
      },
      disableDeleteButton: {
        type: Boolean,
        default: false,
        required: false
      },
      disableCancelButton: {
        type: Boolean,
        default: false,
        required: false
      },
      disableSaveButton: {
        type: Boolean,
        default: false,
        required: false
      },
      disableClearButton: {
        type: Boolean,
        default: false,
        required: false
      },
      disableUploadButton: {
        type: Boolean,
        default: false,
        required: false
      },
      persistent: {
        type: Boolean,
        default: true,
        required: false
      },
      value: {
        type: String,
        default: null
      }
    },

    data: () => ({
      signature: null,
      showConfirmDialog: false,
      theToolbarTitle: ''
    }),

    created () {
      this.signature = this.options
      this.theToolbarTitle = this.toolbarTitle
    },

    watch: {
      options: {
        handler: function (newVal, oldVal) {
          this.signature = newVal
        },
        deep: true
      },
      toolbarTitle: {
        handler: function (newVal, oldVal) {
          this.theToolbarTitle = newVal
        },
        deep: true
      },

      'signature.value': {
        handler: function (newVal, oldVal) {
          this.$emit('update:value', newVal)
        },
        deep: true
      }
    },

    methods: {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      askForConfirmation () {
        this.showConfirmDialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDiscardDeletion (ref) {
        this.showConfirmDialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onConfirmDeletion () {
        this.showConfirmDialog = false
        this.delSignature()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      clearSignature () {
        this.$refs.signature.clear()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openDialog () {
        this.$refs.aggregator.dialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      closeDialog () {
        this.$refs.aggregator.dialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      delSignature () {
        this.onSaveSignature('')
        this.$emit('on-del-signature')
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onSaveSignature (signature) {
        this.signature.value = signature
        if (signature !== '') {
          this.$emit('on-add-signature')
        }
        this.$forceUpdate()
        this.$refs.signature.clear()
        this.closeDialog()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      selectSignatureFile () {
        this.$refs.signature.selectSignatureFile()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setSignature () {
        this.$refs.signature.save()
        this.signature.dialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onUploadError (type, requiredValue) {
        this.$emit('on-upload-error', type, requiredValue)
      }
    }
  }
</script>

<style lang="sass">

.signature-image > div
  background-size: 240px 120px !important

.signature-card
  max-height: 206px !important

.signature-actions
  padding: 18px

.fade
  &-enter-active, &-leave-active, &-leave-to
    transition: .3s ease-out
    position: absolute
    top: 0
    left: 0

  &-enter, &-leave, &-leave-to
    opacity: 0
</style>


// WEBPACK FOOTER //
// src/components/vuetify-signature-aggregator.vue